import { useState, useEffect, useRef } from 'react';
import { Box, Grid, Typography, Tabs, Tab, Button, CircularProgress, TextField, Autocomplete, Pagination } from '@mui/material';
import { Input } from "antd";
import SpinnerLoader from '../../components/general/SpinnerLoader';
import MainButton from '../../components/general/MainButton';
import { useTheme } from '@mui/material/styles';
import { getDateOL, calcularDiferenciaDias, generarNpapeleta } from '../../../utils/function';
import VacationService from '../../../services/vacation';
import { CODES } from '../../../utils/responseCodes';
import { Toast } from '../../../utils/alerts';
import { BallotTable } from './BallotsTable';
import MassiveBallots from '../../components/Vacaciones/MassiveBallots';

const Vacaciones = ({ userToken }) => {
    const persona_id = userToken?.user.persona_id;
    // Para la gestion del buscador por nombre:
    const [subordinados, setSubordinados] = useState([]);
    const [subordinadoSeleccionado, setSubordinadoSeleccionado] = useState(null);
    const [papeletasFiltradas, setPapeletasFiltradas] = useState([]);
    const [loading, setLoading] = useState(true);
    const requestIdRef = useRef(0);
    // para la busqueda por estado:
    const [mostrarSoloPendientes, setMostrarSoloPendientes] = useState(false);
    const [papeletasActuales, setPapeletasActuales] = useState([]);
    // Para la gerstion de los datepickers:
    const Hoy = getDateOL(new Date(), 'short'); //esto es un 
    
    //a1 las validaciones de fechas
    // const [errorSalida, setErrorSalida] = useState(false);
    // const [errorRetorno, setErrorRetorno] = useState(false);

    // Para la gestion del paginador:
    const [paginaActual, setPaginaActual] = useState(1);
    const itemsPorPagina = 5;
    const totalPaginas = Math.ceil(papeletasFiltradas.length / itemsPorPagina);
    const papeletasPaginadas = papeletasFiltradas.slice(
        (paginaActual - 1) * itemsPorPagina,
        paginaActual * itemsPorPagina
    );
    // Otros:
    const theme = useTheme();
    const [openModalLoader, setOpenModalLoader] = useState(true);
    const [body, setBody] = useState(0);
    const [MisPapeletas, setMisPapeletas] = useState();
    const initialFormState = {
        persona_id: persona_id || null,
        dateStart: Hoy,
        dateSalida: Hoy,
        dateRetorno: Hoy,
        codigoTrabajador: '',
        numeroPapeleta: '',
        solicitante: '',
        documentoIdentidad: userToken?.user.numdoc || '',
        totalDias: '0',
    };
    const [formData, setFormData] = useState(initialFormState);

    useEffect(() => {
        Promise.all([
            obtenerDatosParaPapeleta(),
            CalcularPendientes(),
            obtenerMisPapeletas(),
            obtenerPapeletasSubordinados(),
            NombresDeMisSubordinados(),
            SetearBusquedaPordefecto()
        ]).then(() => {
            setOpenModalLoader(false)
            setLoading(false)
        });
    }, []);

    const handleChangeBody = (event, newValue) => {
        setBody(newValue);
        Promise.all([
            CalcularPendientes(),
            obtenerMisPapeletas(),
            obtenerPapeletasSubordinados(),
            NombresDeMisSubordinados()
        ]).then(() => setOpenModalLoader(false));
    };

    const handleInputChange = (field, value) => {
        const updatedForm = { ...formData, [field]: value };
        // if (field === 'dateSalida') setErrorSalida(false); //a1
        // if (field === 'dateRetorno') setErrorRetorno(false); //a1
        if (updatedForm.dateSalida && updatedForm.dateRetorno) {
            const dias = calcularDiferenciaDias(updatedForm.dateSalida, updatedForm.dateRetorno);
            updatedForm.totalDias = dias >= 0 ? dias : '';
        } else {
            updatedForm.totalDias = '';
        }
        setFormData(updatedForm);
    };

    const CalcularPendientes = async () => {
        try {
            const response = await VacationService.CalculateSlopes(formData.persona_id);
            if (response?.status === CODES.SUCCESS_200) {
                const { totalDiasTomados, totalPapeletasAprobadas } = response.data;
                setFormData(prev => ({
                    ...prev,
                    totalDiasTomados: totalDiasTomados,
                    totalPapeletasAprobadas: totalPapeletasAprobadas
                }));
            } else {
                Toast.fire({
                    icon: 'error',
                    title: (response?.message || 'Error en el estado de la respuesta')
                });
            }
        } catch (error) {
            // Toast.fire({
            //     icon: 'error',
            //     title: error?.response?.data?.error || 'Error al calcular los dias pendientes'
            // });
            console.log(error?.response?.data?.error || 'Error al calcular los dias pendientes');
        }
    };

    const obtenerDatosParaPapeleta = async () => {
        try {
            const response = await VacationService.GenerateBallotData(formData.persona_id);
            if (response?.status === CODES.SUCCESS_200) {
                const { codSghh, n_papeleta, nombreCompleto, nombreJefe, idJefe, prefijo, empresa, email } = response.data;
                const numeroPapeletaFinal = generarNpapeleta(nombreCompleto,n_papeleta,persona_id);
                setFormData(prev => ({
                    ...prev,
                    codigoTrabajador: codSghh,
                    numeroPapeleta: numeroPapeletaFinal,
                    solicitante: nombreCompleto,
                    jefe: nombreJefe,
                    idJefe: idJefe,
                    prefijo: prefijo,
                    empresa: empresa,
                    correo: email,
                    totalDias: '0',
                    dateSalida: Hoy,
                    dateRetorno: Hoy
                }));
            } else {
                Toast.fire({
                    icon: 'error',
                    title: (response?.message || 'Error en el estado de la respuesta')
                });
            }
        } catch (error) {
            // Toast.fire({
            //     icon: 'error',
            //     title: error?.response?.data?.error || 'Error al obtener Datos Para la Papeleta'
            // });
            console.log(error?.response?.data?.error || 'Error al obtener Datos Para la Papeleta')
        }
    };

    const SelecionarSubordinado = async (e, nuevoValor) => {
        const currentRequestId = ++requestIdRef.current;
        setLoading(true);
        setSubordinadoSeleccionado(nuevoValor);
        let response;
        if (nuevoValor?.id_persona === 0 || !nuevoValor) {
            // Mostrar todos
            response = await VacationService.ballotsSubordinates(persona_id);
        } else {
            // Mostrar filtrado
            response = await VacationService.GetBallotsByPersona(nuevoValor.id_persona);
        }
        // Solo actualiza si esta es la solicitud más reciente
        // if (requestIdRef.current === currentRequestId) {
        //     setPapeletasActuales(response.data); // conjunto base, sin filtro
        //     if (mostrarSoloPendientes) {
        //         setPapeletasFiltradas(response.data.filter(p => p.estado === '1'));
        //     } else {
        //         setPapeletasFiltradas(response.data);
        //     }
        // }
        // if (mostrarSoloPendientes) {
        //     setPapeletasFiltradas(response.data.filter(p => p.estado === '1'));
        // } else {
        //     setPapeletasFiltradas(response.data);
        // }
        if (requestIdRef.current === currentRequestId) {
            setPapeletasActuales(response.data);
            const nuevasPapeletas = mostrarSoloPendientes
                ? response.data.filter(p => p.estado === '1')
                : response.data;

            setPapeletasFiltradas(nuevasPapeletas);
            setPaginaActual(1); // 👈 Asegura que se muestre la primera página
        }
        setLoading(false);
    }

    async function NombresDeMisSubordinados() {
        try {
            const response = await VacationService.GetMySubordinates(persona_id);
            setSubordinados([{ id_persona: 0, nombre: 'Todos' }, ...response.data]);
        } catch (error) {
            // Toast.fire({
            //     icon: 'error',
            //     title: error?.response?.data?.error || 'Error al obtener los nombres de los subordinados'
            // });
            console.log(error?.response?.data?.error || 'Error al obtener los nombres de los subordinados');
        }
    }

    async function SetearBusquedaPordefecto() {
        try {
            const response = await VacationService.ballotsSubordinates(persona_id);
            setPapeletasFiltradas((prev) => {
                // Si no hay datos ya filtrados, cargar todos
                if (prev.length === 0) {
                    return response.data;
                }
                return prev; // Mantener los que ya estaban si el usuario actuó antes
            });
            setSubordinadoSeleccionado((prev) => {
                if (!prev) {
                    return { id_persona: 0, nombre: 'Todos' };
                }
                return prev;
            });
        } catch (error) {
            console.log(error?.response?.data?.error || 'Error al llenar los datos en el autocompletable');
        }
    }

    const alternarFiltroPendientes = () => {
        setMostrarSoloPendientes((prev) => {
            const nuevoValor = !prev;

            if (nuevoValor) {
                // Activar filtro: mostrar solo pendientes
                // const pendientes = papeletasFiltradas.filter(p => p.estado === '1');
                const pendientes = papeletasActuales.filter(p => p.estado === '1');
                setPapeletasFiltradas(pendientes);
            } else {
                // Desactivar filtro: restaurar el conjunto original según el subordinado actual
                setPapeletasFiltradas(papeletasActuales);
            }
            setPaginaActual(1);
            return nuevoValor;
        });
    };

    const actualizarPapeletasFiltradas = async () => {
        try {
            setLoading(true);
            const idPersona = subordinadoSeleccionado?.id_persona;
            let response;
            if (!idPersona || idPersona === 0) {
                response = await VacationService.ballotsSubordinates(persona_id);
            } else {
                response = await VacationService.GetBallotsByPersona(idPersona);
            }
            setPapeletasActuales(response.data);
            if (mostrarSoloPendientes) {
                setPapeletasFiltradas(response.data.filter(p => p.estado === '1'));
            } else {
                setPapeletasFiltradas(response.data);
            }
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: 'Error al actualizar las papeletas'
            });
        } finally {
            setLoading(false);
        }
    };

    async function obtenerMisPapeletas() {
        try {
            const response = await VacationService.Myballots(persona_id);
            setMisPapeletas(response.data);
        } catch (error) {
            // Toast.fire({
            //     icon: 'error',
            //     title: error?.response?.data?.error || 'Error al obtener Mis Papeletas'
            // });
            console.log('Error al obtener Mis Papeletas');
        }
    }

    async function obtenerPapeletasSubordinados() {
        try {
            const response = await VacationService.ballotsSubordinates(persona_id);
            setPapeletasActuales(response.data);
        } catch (error) {
            // Toast.fire({
            //     icon: 'error',
            //     title: error?.response?.data?.error || 'Error al obtener las Papeletas de tus Subordinados'
            // });
            console.log(error?.response?.data?.error || 'Error al obtener las Papeletas de tus Subordinados')
        }
    }

    async function CrearPapeleta() {
        // a1
        // if (formData.dateSalida < Hoy) {
        //     setErrorSalida(true);
        //     Toast.fire({
        //         icon: 'error',
        //         title: 'La fecha de salida debe ser posterior a hoy.',
        //     });
        //     return;
        // }
        // if (formData.dateRetorno < Hoy) {
        //     setErrorRetorno(true);
        //     Toast.fire({
        //         icon: 'error',
        //         title: 'La fecha de reincorporación debe ser posterior a hoy.',
        //     });
        //     return;
        // }

        if (formData.dateSalida > formData.dateRetorno) {
            // setErrorRetorno(true); //a1
            Toast.fire({
                icon: 'error',
                title: 'La fecha de reincorporación no debe ser anterior a la fecha de salida.'
            });
            return;
        }
        if (formData.totalDias <= 0) {
            Toast.fire({
                icon: 'error',
                title: 'Debes ingresar al menos un día tomado.'
            });
            return;
        }
        // console.log(formData);
        const formDataToSend = new FormData();
        formDataToSend.append("fecha_salida", formData.dateSalida);
        formDataToSend.append("fecha_reincorporacion", formData.dateRetorno);
        formDataToSend.append("n_diasTomados", formData.totalDias);
        formDataToSend.append("persona_id", formData.persona_id);
        formDataToSend.append("n_papeleta", formData.numeroPapeleta);
        formDataToSend.append("fecha_registro", formData.dateStart);
        formDataToSend.append("personaMod", formData.idJefe);
        try {
            setOpenModalLoader(true);
            const result = await VacationService.CreateBallot(formDataToSend);
            obtenerMisPapeletas();
            obtenerDatosParaPapeleta();
            setBody(0);
            Toast.fire({
                icon: 'success',
                title: result.message
            });
        } catch (error) {
            console.error('Error al crear papeleta:', error);
        } finally {
            setOpenModalLoader(false);
        }
    }

    // function RenderizarPapeletasMasivas() {
    //     const listaDesPerfiles = [9, 7, 1];
    //     const desPerfilUsuario = userToken.user.perfil.id_perfil;
    //     return listaDesPerfiles.includes(desPerfilUsuario);
    // }

    const pestanias = [
        {
            label: 'Mis papeletas',
            content: (
                <>
                    <Grid container justifyContent="space-between">
                        <Grid item xs={12} md={6} sx={{ margin: { xs: '2rem 0 0 0', md: '2.5rem 0 1.5rem 3rem' } }}>
                            <Typography> Nombre: <small className="text-muted"> {formData.solicitante} </small> </Typography>
                            <Typography> Empresa: <small className="text-muted"> {formData.empresa} </small> </Typography>
                            <Typography> Año: <small className="text-muted"> {new Date(Hoy).getFullYear()} </small> </Typography>
                            <Typography> Días aprobados hasta ahora: <small className="text-muted"> {formData.totalDiasTomados} </small> </Typography>
                            <Typography> # Papeletas aprobadas: <small className="text-muted"> {formData.totalPapeletasAprobadas} </small> </Typography>
                        </Grid>
                        <Grid item xs={6} md={3} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', margin: '2.5rem 3rem 1.5rem 0' }}>
                            <Button fullWidth variant="contained" color="primary" onClick={() => setBody(1)}>
                                Nueva Papeleta
                            </Button>
                        </Grid>
                    </Grid>
                    <BallotTable
                        Papeletas={MisPapeletas}
                        TabMisAprobaciones={false} // por defecto es true y hace cosas como mostrar el nombre
                        cambiarLoader={setOpenModalLoader}
                        QuePapeletasCargar={obtenerMisPapeletas}
                    />
                </>
            )
        },
        {
            label: 'Nueva Papeleta',
            content: (
                <>
                    <Box textAlign={'center'} mt={5}>
                        <Typography variant="h4" gutterBottom color={'primary'}>
                            Papeleta de vacaciones
                        </Typography>
                    </Box>
                    <Grid container justifyContent="center" alignItems="center" mt={2}>
                        <Grid item xs={12} sm={10} md={10}>
                            <Grid container p={1}>

                                {/* Código de trabajador */}
                                <Grid item xs={8} style={{ marginTop: '0.5rem' }}>
                                    <fieldset>
                                        <legend style={{ fontSize: 'medium' }}>Código de trabajador</legend>
                                        <Input
                                            type="text"
                                            value={formData.codigoTrabajador}
                                            disabled
                                            style={inputStyle(true)}
                                        />
                                    </fieldset>
                                </Grid>

                                {/* N° de papeleta */}
                                <Grid item xs={4} style={{ marginTop: '0.5rem' }}>
                                    <fieldset>
                                        <legend style={{ fontSize: 'medium' }}>N° de papeleta</legend>
                                        <Input
                                            type="text"
                                            value={formData.numeroPapeleta}
                                            disabled={!!formData.numeroPapeleta}
                                            style={inputStyle(true)}
                                        />
                                    </fieldset>
                                </Grid>

                                {/* Nombre del Solicitante */}
                                <Grid item xs={8} style={{ marginTop: '0.8rem' }}>
                                    <fieldset>
                                        <legend style={{ fontSize: 'medium' }}>Nombre del Solicitante</legend>
                                        <Input
                                            type="text"
                                            value={formData.solicitante}
                                            disabled={!!formData.solicitante}
                                            style={inputStyle(true)}
                                        />
                                    </fieldset>
                                </Grid>

                                {/* DNI/CE/PAS */}
                                <Grid item xs={4} style={{ marginTop: '0.8rem' }}>
                                    <fieldset>
                                        <legend style={{ fontSize: 'medium' }}>DNI/CE/PAS</legend>
                                        <Input
                                            type="text"
                                            value={formData.documentoIdentidad}
                                            disabled
                                            style={inputStyle(true)}
                                        />
                                    </fieldset>
                                </Grid>

                                {/* El jefe */}
                                <Grid item xs={8} style={{ marginTop: '0.5rem' }}>
                                    <fieldset>
                                        <legend style={{ fontSize: 'medium' }}>Jefe inmediato</legend>
                                        <Input
                                            type="text"
                                            value={formData.jefe}
                                            disabled
                                            style={inputStyle(true)}
                                        />
                                    </fieldset>
                                </Grid>

                                {/* Mensaje central */}
                                <Grid item xs={12} style={{ marginTop: '2rem', marginBottom: '1rem' }}>
                                    <fieldset>
                                        <legend style={{ fontSize: 'large' }}>
                                            Solicitó autorización para ausentarse del trabajo por vacaciones
                                        </legend>
                                    </fieldset>
                                </Grid>

                                {/* Fecha de salida */}
                                <Grid item xs={12} sm={6} md={6} style={{ marginTop: '0.5rem' }}>
                                    <fieldset>
                                        <legend style={{ fontSize: 'medium' }}>Fecha de salida:</legend>
                                        <Input
                                            type="date"
                                            // min={Hoy} //a1
                                            defaultValue={formData.dateSalida}
                                            // status={errorSalida ? 'error' : ''} //a1
                                            onChange={(e) => handleInputChange('dateSalida', e.target.value)}
                                            style={inputStyle()}
                                        />
                                    </fieldset>
                                </Grid>

                                {/* Fecha de reincorporación */}
                                <Grid item xs={12} sm={6} md={6} style={{ marginTop: '0.5rem' }}>
                                    <fieldset>
                                        <legend style={{ fontSize: 'medium' }}>Fecha de reincorporación:</legend>
                                        <Input
                                            type="date"
                                            // min={Hoy} //a1
                                            defaultValue={formData.dateRetorno}
                                            // status={errorRetorno ? 'error' : ''} //a1
                                            onChange={(e) => handleInputChange('dateRetorno', e.target.value)}
                                            style={inputStyle()}
                                        />
                                    </fieldset>
                                </Grid>

                                <Grid container justifyContent="space-between">
                                    {/* Aqui estaba el Boton para subir archivo */}
                                    <Grid item xs={6} md={3} style={{ marginTop: '0.5rem' }}> </Grid>

                                    {/* Total de días */}
                                    <Grid item xs={6} md={3} style={{ marginTop: '0.5rem' }}>
                                        <fieldset>
                                            <legend style={{ fontSize: 'medium' }}>Total de días tomados:</legend>
                                            <Input
                                                type="text"
                                                value={formData.totalDias}
                                                disabled
                                                style={inputStyle(true)}
                                            />
                                        </fieldset>
                                    </Grid>
                                </Grid>

                            </Grid>
                            {/* Botones */}
                            <Grid container sx={{ my: 4 }} justifyContent={{ xs: 'center', md: 'flex-end' }}>
                                <Grid item xs={12} md={5}>
                                    <Grid container spacing={{ xs: 0, md: 2 }}>
                                        <Grid item xs={6}>
                                            <MainButton
                                                fullWidth
                                                title="Cancelar"
                                                color="white"
                                                background={theme.palette.primary.main}
                                                onClick={() => setBody(0)}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <MainButton
                                                fullWidth
                                                title="Registrar"
                                                color="white"
                                                background={theme.palette.primary.main}
                                                onClick={CrearPapeleta}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            )
        }
    ];

    if (subordinados.length > 1) {
        pestanias.push({
            label: 'Aprobaciones',
            content: (
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container justifyContent="space-between">
                        <Grid item xs={12} md={4} sx={{ margin: { xs: '2rem 0 0 0', md: '2.5rem 0 1.5rem 3rem' } }}>
                            <Autocomplete
                                fullWidth
                                size="small"
                                options={subordinados}
                                getOptionLabel={(option) => option?.nombre ?? ''}
                                isOptionEqualToValue={(option, value) => option.id_persona === value.id_persona}
                                value={subordinadoSeleccionado}
                                onChange={SelecionarSubordinado}
                                renderInput={(params) => <TextField {...params} label="Buscar subordinado" />}
                            />
                        </Grid>
                        <Grid item xs={12} md={3} sx={{ margin: { xs: '1rem 0', sm: '2.5rem 3rem 1.5rem 0' } }} >
                            <Button
                                fullWidth
                                variant="contained"
                                color={mostrarSoloPendientes ? 'secondary' : 'primary'}
                                onClick={alternarFiltroPendientes}
                                disabled={loading}
                            >
                                {mostrarSoloPendientes ? 'Todos' : 'Pendientes'}
                            </Button>
                        </Grid>
                    </Grid>
                    {loading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                            <CircularProgress />
                        </Box>
                    ) : (
                        <>
                            <BallotTable
                                Papeletas={papeletasPaginadas}
                                cambiarLoader={setOpenModalLoader}
                                QuePapeletasCargar={actualizarPapeletasFiltradas}
                                correo={formData.correo}
                            />
                            <Box mt={2} display="flex" justifyContent="center">
                                <Pagination
                                    count={totalPaginas}
                                    page={paginaActual}
                                    onChange={(event, value) => setPaginaActual(value)}
                                    color="primary"
                                />
                            </Box>
                        </>
                    )}
                </Box>
            )
        });
    }

    // if (RenderizarPapeletasMasivas()) {
    //     pestanias.push({
    //         label: 'Papeletas Masivas',
    //         content: (
    //             <MassiveBallots
    //                 id_usuario={userToken.user.id_usuario}
    //                 id_persona_aprovador={persona_id}
    //                 cambiarLoader={setOpenModalLoader}
    //             />
    //         )
    //     });
    // }

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Box marginTop={'2rem'} sx={{ width: '100%' }}>
                <Tabs value={body} onChange={handleChangeBody} centered>
                    {pestanias.map((item, index) => (
                        <Tab key={index} label={item.label} />
                    ))}
                </Tabs>
            </Box>

            <Grid container justifyContent="center" alignItems="center" mt={0}>
                <Grid item xs={12} sm={10} md={10} paddingX={'1rem'}>
                    {pestanias[body]?.content}
                </Grid>
            </Grid>

            {/* Loader */}
            <SpinnerLoader open={openModalLoader} />
        </Box>
    );
};

// Estilo común para los inputs
const inputStyle = (disabled = false) => ({
    fontSize: 'medium',
    paddingTop: '0.5rem',
    width: '95%',
    color: "rgba(0, 0, 0, 0.65)",
    backgroundColor: disabled ? "#EBEAEAFF" : "#ffffff",
});

export default Vacaciones;
